<script>
import { store } from './store.js'

export default {
  props: ['item'],
  data() {
    return {
      store
    }
  },
  mounted() {
  },
  updated() {
    
  },

   computed: {
    // a computed getter
    mediaId() {
      var output = this.item.id + '-media-button'; 
      return  output;
    },

    mediaDiv() {
      var output = this.item.id + '-media-button'; 
      return  output;
    },

  },
  methods: {
  }
};
</script>

<template>
   
					<div class="og-inside">
						<div class="tabs">
							<ul>
								<li><a href="#tab-01">Design</a></li>
								<li><a href="#tab-02">Position</a></li>
							</ul>
							<div id="tab-01">
								<div class="form-wrap">

									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
											<label for="color">Color</label>
											<input v-model="item.bgcolor" placeholder="color" type="color">
										</div>
                    <div class="og-form-field og-form-field-half">
											<label for="width">Opacity (100)</label>
											<input v-model="item.bgopacity" type="number">
										</div>
									</div><!-- .og-form-fields-row -->

									<h3 class="">Border</h3>

									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
												<label>Width</label>
												<input v-model="item.borderwidth" placeholder="width" min="0" type="number">
											</div>
											<div class="og-form-field og-form-field-half">
												<label>Style</label>
												<select v-model="item.borderstyle">
													<option value="solid">Solid</option>
													<option value="double">Double</option>
													<option value="dotted">Dotted</option>
													<option value="dashed">Dashed</option>
												</select>			
											</div>
									</div>

									<div class="og-form-fields-row">
											<div class="og-form-field og-form-field-half">
												<label>Color</label>
												<input v-model="item.bordercolor" placeholder="color" type="color">
											</div>
												<div class="og-form-field og-form-field-half">
												<label>Radius</label>
												<input v-model="item.borderradius" placeholder="width" min="0" type="number">
											</div>
									</div>

								</div><!-- .form-wrap -->					
							</div>
							<div id="tab-02">
								<div class="form-wrap">
									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
											<label for="width">Width</label>
											<input v-model="this.item.frame.width" type="number">
										</div>
										<div class="og-form-field og-form-field-half">
											<label for="height">Height</label>
											<input v-model="this.item.frame.height" type="number">
										</div>
									</div>
									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-third">
											<label for="width">Top</label>
											<input v-model="this.item.frame.translatey" type="number">
										</div>
										<div class="og-form-field og-form-field-third">
											<label for="height">Left</label>
											<input v-model="this.item.frame.translatex" type="number">
										</div>
										<div class="og-form-field og-form-field-third">
											<label for="rotation">Rotation</label>
											<input v-model="this.item.frame.rotate" type="number">
										</div>
									</div>
								</div><!-- .form-wrap -->
							</div>
						</div><!-- .tabs -->
					</div><!-- .inside -->
		

</template>